import {Route, Switch} from "react-router-dom";
import AdminToBuyerOfferProductList from "./AdminToBuyerOfferProductList";
import AdminToBuyerOfferProductView from "./AdminToBuyerOfferProductView";


const App = ({match}) => (
    <Switch>
        <Route exact path={`${match.url}`} component={AdminToBuyerOfferProductList}/>
        <Route path={`${match.url}/details/:id?`} component={AdminToBuyerOfferProductView}/>
    </Switch>
);

export default App;